import { render, staticRenderFns } from "./message.vue?vue&type=template&id=f828bffe&scoped=true"
import script from "./message.vue?vue&type=script&lang=js"
export * from "./message.vue?vue&type=script&lang=js"
import style0 from "./message.vue?vue&type=style&index=0&id=f828bffe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f828bffe",
  null
  
)

export default component.exports